import { serverStringToBrowserDate } from "../utils/date-utils";
import fetchWrapper from "../utils/fetchWrapper";



const makeDatesForAlert = (alert) => {
  var newAlert = { ...alert };
  newAlert.publishDate = serverStringToBrowserDate(newAlert.publishDate);
  newAlert.unpublishDate = serverStringToBrowserDate(newAlert.unpublishDate);
  if (newAlert?.type?.toLowerCase() === "downtime" && newAlert.startDate) {
    newAlert.startDate = serverStringToBrowserDate(newAlert.startDate);
  } else {
    newAlert.startDate = null;
  }
  return newAlert;
};

const transformUserAlertDataOnClient = (userAlerts) => {
  let result = !userAlerts ? {} : { ...userAlerts };
  if (!result.systemAlerts) {
    result.systemAlerts = [];
  }
  var newScreen = { ...result };
  newScreen.systemAlerts = newScreen.systemAlerts.map(makeDatesForAlert);
  //todo: make dates for actionables as they come in
  return newScreen;
};

export class userAlertService {
  constructor(r) {
    this.req = r;
  }

  async getUserAlerts() {
    try {
      /*var p = new Promise(resolve => resolve({ systemAlerts: [] }));
      return p;*/

      const url = `/api/alerts`;
      const data = await fetchWrapper({ url: url, req: this.req });
      return transformUserAlertDataOnClient(data);
    } catch (e) {
      console.log(`load user alerts failed!!!: ${e}`);
      return { systemAlerts: [] };
    }
  }
  async dismissSystemAlert(alert) {
    try {
      const url = `/api/alerts/system/${alert.id}`;
      const result = await fetchWrapper({
        url: url,
        req: this.req,
        fetchOptions: {
          method: "DELETE",
        },
      });
      return result;
    } catch (e) {
      console.log(`dismiss alert failed: ${e}`);
    }
  }
}


export default userAlertService;
